export const BRIDGE_HANDLER = {
  NATIVE_PAY: 'nativePay',
  REFRESH_CART: 'refreshCart',
  SEND_SOCKET: 'sendSocket',
  UPDATE_PROFILE: 'updateProfile',
  OPEN_ROOM: 'openRoom',
  TOKEN_EXPIRED: 'tokenExpired',
  OPEN_ROOM_DETAIL: 'openRoomDetail',
  SEARCH: 'search',
  PROFILE_UPDATED: 'profileUpdated',
  NATIVE_LOGOUT: 'nativeLogout',
  OPEN_COUMMUNICATION_CHANNEL: 'openCommunicationChannel',
  OPEN_WEB_VIEW: 'openWebView',
  COPY_TO_CLIPBOARD: 'copyToClipboard',
  PROCEED_PAYMENT: 'proceedPayment',
  CLOSE_WEB_VIEW: 'closeWebView',
  COMPLETE_PAYMENT: 'completePayment',
  DOWNLOAD_FILE: 'downloadFile',
  DELETE_ACCOUNT: 'deleteAccount',
  OPEN_PDF: 'openPDF',
  GO_SHOP: 'goShop',
  OPEN_URL_IN_SYSTEM_BROWSER: 'openUrlInSystemBrowser',
  OPEN_LINE_OFFICIAL_ACCOUNT: 'openLineOfficialAccount',
}
